<template>
    <div v-if="showPrice && price.discount && !price.hiddenDiscount">
        <del data-cy="before-discount-price" class="text-body-2 d-block">{{ $filters.price(priceBeforeDiscount) }}</del>
        <v-chip color="info" data-cy="discount-percentage" label size="x-small" variant="flat">
            &minus;{{ discountLabel }}%{{ price.promoCode ? ' ' + $t('by_promo_code') : '' }}
        </v-chip>
    </div>
</template>

<script lang="ts">
    import {Vue, Component, Prop} from 'vue-facing-decorator'

    @Component
    export class DiscountLabel extends Vue {
        @Prop({required: true}) price

        get priceBeforeDiscount() {
            return {
                amount: ((this.price.originalAmount || this.price.amount) / (1 - this.price.discount / 100)).toFixed(2),
                currency: this.price.originalCurrency || this.price.currency,
            }
        }

        get discountLabel() {
            return this.price.discount.toFixed(2)
        }

        get showPrice() {
            return true
        }
    }

    export default DiscountLabel
</script>
